<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center"
    >
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/pages/forgot-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Recupere o Acesso a sua conta</h4>
                  <p>
                    Insira seu endereço de e-mail e enviaremos instruções sobre
                    como redefinir sua senha.
                  </p>
                </div>

                <vs-input
                  type="email"
                  label-placeholder="Email"
                  v-model="email"
                  class="w-full mb-8"
                />
                <vs-alert
                  v-if="this.errorInfo"
                  color="danger"
                  title="Erro"
                  active="true"
                >
                  {{ this.errorInfo }}
                </vs-alert>
                <br />
                <vs-button type="border" to="/" class="px-4 w-full md:w-auto"
                  >Voltar</vs-button
                >
                <vs-button
                  class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                  @click="forgotPassword()"
                  :disabled="!isFormValid"
                  >Recuperar Senha</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { baseApiUrl } from "@/global";
import axios from "axios";
export default {
  data() {
    return {
      email: "",
      errorInfo: "",
    };
  },
  computed: {
    isFormValid() {
      return !this.errors.any() && this.email;
    },
  },
  methods: {
    async forgotPassword() {
      let result = this.$validator.validateAll();
      if (result) {
        try {
          this.$vs.loading();
          let res = await axios.post(`${baseApiUrl}/user/forgotPassword`, {
            email: this.email,
          });
          if (res.data) {
            this.errorInfo = "";
            this.$router.push(`/pages/forgot-password-success`).catch(() => {});
          } else {
            console.log('E-mail não encontrado.')
            this.errorInfo = "E-mail não encontrado.";
          }
        } catch (error) {
          this.$vs.notify({
            title: "Erro",
            text: "Problema ao buscar e-mail.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        } finally {
          this.$vs.loading.close();
        }
      }
    },
  },
};
</script>
